
const locales = {"uk":{"notifications.error_title":"Помилка"},"ru":{"notifications.error_title":"Ошибка"},"en":{"notifications.error_title":"Error"},"be":{"notifications.error_title":"Ошибка"},"md":{"notifications.error_title":"Error"}}

export default locales
